<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      name
      status
      btn-add
      @handleAdd="handleEdit"
      @handleSearch="getData"
    ></searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="240">
        <template slot-scope="scope">
          <el-button
            @click="handleEdit(scope.row)"
            style="marginLeft:10px"
            type="text"
            size="mini"
          >
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '#67C23A' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增商铺Dialog-->
    <el-dialog
      title="添加/修改便民服务类型"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="类型名称" prop="name" label-width="100px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="类型名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型描述" label-width="100px">
          <el-input
            v-model="form.description"
            type="textarea"
            size="medium"
            placeholder="类型描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "axios"
import "@/assets/http/utils.ts"
import { downloadFile } from "@/assets/http/utils"
import apiUrl from "@/assets/http/apiUrl"

export default {
  name: "newsType",

  data() {
    return {
      // 页面初始数据
      totalElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      // 搜索栏初始化
      searchForm: {
        status: "",
      },

      // 表头初始化
      tableHeader: {
        name: "类型名称",
        createTime: "创建时间",
        statusName: "状态",
      },

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,
      dialogUploadVisible: false,

      // 上传文件列表
      file: "",

      // 新增表单
      form: {
        uid: "",
        name: "",
        description: "",
      },
      examineStatus: false, //审核类型是否通过
      // 表单验证规则
      rules: {
        name: {
          required: true,
          message: "请输入类型名称",
          trigger: "blur",
        },
      },
    }
  },
  methods: {
    /*请求数据*/
    getData() {
      this.request({
        url: "/manager/convenience/findTypeByCondition",
        method: "get",
        params: {
          page: this.page,
          size: this.size,
          name: this.searchForm.name,
          examineStatus: this.searchForm.examineStatus,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量*/
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转*/
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用*/
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/convenience/updateAvailableType",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    // changeStatus(row, e) {
    //   console.log(row, e)
    //   let status
    //   if (e) {
    //     status = 3
    //   } else {
    //     status = 4
    //   }
    //   this.request({
    //     url: "/manager/convenience/releaseOrShieldType",
    //     data: {
    //       uid: rowData.uid,
    //       status: status,
    //     },
    //     method: "post",
    //   })
    //     .then((res) => {
    //       this.$message.success("操作成功")
    //       this.getData()
    //     })
    //     .catch((err) => {
    //       this.$message.error(err.message)
    //     })
    // },

    /*编辑*/
    handleEdit(rowData) {
      this.form = { ...rowData }
      this.dialogFormVisible = true
    },

    /*添加操作
     * */
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除*/
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/convenience/deleteType",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交*/
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogFormVisible = false

          this.request({
            url: "/manager/convenience/addOrUpdateType",
            data: {
              uid: this.form.uid,
              name: this.form.name,
              description: this.form.description,
            },
            method: "post",
          })
            .then(res => {
              this.getData()
              this.form = {}
            })
            .catch(err => {})
        }
      })
    },

    /*dialog取消*/
    dialogCancel() {
      this.dialogFormVisible = false
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped lang="scss"></style>
